// Project
import request from "../request";

/**
 * Get a Jira ticket.
 *
 * @param {string} jiraTicketNumber
 * @returns {Promise<{
 *   summary: string,
 *   assignee: string,
 *   components: string[],
 *   created: Date | null,
 *   description: string,
 *   priority: string,
 *   reporter: string,
 *   status: string,
 *   updated: Date | null
 * }>}
 */
export const getJiraTicket = async (jiraTicketNumber) => {
	const response = await request({
		url: `api/jira/ticket/${jiraTicketNumber}`,
		method: "GET",
	});

	const formattedData = response.data;
	formattedData.created = formattedData.created ? new Date(formattedData.created) : null;
	formattedData.updated = formattedData.updated ? new Date(formattedData.updated) : null;

	return formattedData;
};
